import { createContext } from "react";
import { TripData } from "../engine/ConciergeCardViewModel";

export const CardContext = createContext<{
	selectedCard: TripData | null,
	setSelectedCard: (card: TripData | null) => void
}>({ selectedCard: null, setSelectedCard: () => { } });
